import { createTheme } from "@mui/material";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 768,
            md: 1280,
            lg: 1920,
            xl: 2560,
        },
    },
    palette: {
        axon: {
            main: "#FEC62E",
            hover: "rgba(254, 198, 46, 0.8)",
            subtle: "rgba(254, 198, 46, 0.2)",
        },
    },
    typography: {
        fontFamily: ["Barlow", "Roboto", "Helvetica Neue", "Arial", "sans-serif"].join(","),
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        // variant sizes
        main: {
            fontSize: "30px",
            lineHeight: "36px",
        },
        title: {
            fontSize: "24px",
            lineHeight: "30px",
        },
        subtitle: {
            fontSize: "20px",
            lineHeight: "26px",
        },
        body: {
            fontSize: "16px",
            lineHeight: "22px",
        },
        detail: {
            fontSize: "14px",
            lineHeight: "20px",
        },
        small: {
            fontSize: "12px",
            lineHeight: "18px",
        },
    },
    // zeroing everything out
    components: {
        MuiImageListItemBar: {
            styleOverrides: {
                root: {
                    padding: 0,
                    margin: 0,
                    fontSize: "1em",
                },
                titleWrap: {
                    padding: 0,
                },
                title: {
                    fontSize: "1em",
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    padding: "0.5rem 0 0.5rem 1rem",
                    fontSize: "1rem",
                },
            },
        },
        MuiContainer: {
            defaultProps: {
                disableGutters: true,
                maxWidth: "md",
            },
            styleOverrides: {
                root: ({ theme }) =>
                    theme.unstable_sx({
                        height: "100%",
                        pb: "20px",
                        px: { xs: "10px", sm: "20px", md: "30px" },
                    }),
            },
        },
    },
});

export default theme;

